"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadBlob = downloadBlob;
function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}
//# sourceMappingURL=utils.js.map